// leaflet map component that exposes latitude and longitude by user selectin the marker on map

import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Icon } from 'leaflet';
import { useRef } from 'react';
import { useMemo } from 'react';
import { map } from 'lodash';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});
// L.Marker.prototype.options.icon = DefaultIcon;

function LocateMeButton({ onChange }) {
  const map = useMapEvents({
    click(e) {
      onChange(e.latlng);
    },
    // dragend(e) {
    //   console.log(map.getCenter());

    //   onChange(map.getCenter());
    // },

    locationfound(e) {
      onChange(e.latlng);
      map.flyTo(e.latlng, map.getZoom());
    },
  });
  // mapInstance.current?.on('dragend', (e) => {
  //   console.log(e);
  // });
  // console.log(map);

  return (
    <div
      onClick={() => map?.locate()}
      className="cursor-pointer map-button locate-button bg-blue-400 p-2 rounded-xl"
    >
      مکان من
    </div>
  );
}

const Location = ({ location, onChange }) => {
  const [position, setPosition] = useState(location || [35.724600858, 51.4340615272]);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          // setPosition(marker.getLatLng());
          onChange(marker.getLatLng());
        }
      },
      click(e) {
        console.log(e);
      },
    }),
    [],
  );
  // const handleMapClick = (e) => {
  //   setPosition([e.latlng.lat, e.latlng.lng]);
  //   onChange([e.latlng.lat, e.latlng.lng]);
  // };

  const handleClickMapMarker = () => {
    // get center

    console.log(mapInstance.current);
    // if (center) {
    //   console.log(center);
    //   // setPosition(center);
    //   onChange(center);
    // }
  };

  const handleLocateMe = (e) => {
    mapInstance.current.locate();
    console.log(mapInstance.current);
    // setPosition(e.latlng);
    // map.flyTo(e.latlng, map.getZoom());
  };

  return (
    <MapContainer
      ref={mapInstance}
      className="w-full md:w-[500px]"
      center={position}
      zoom={13}
      style={{ height: '400px', minWidth: '300px' }}

      // onClick={handleMapClick}
    >
      <TileLayer url="https://raster.raah.ir/tiles/rendered/{z}/{x}/{y}.jpg?token=fdsdfsasfdsdafadse4wrtertwhfgfds&style=raster_address_parcel" />

      {/* <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">
          OpenStreetMap</a> contributors'
      /> */}
      {/* <div className="map-marker"></div> */}
      {/* <Marker position={position}>
        <Popup>Your location</Popup>
      </Marker> */}
      <Marker
        icon={DefaultIcon}
        draggable
        eventHandlers={eventHandlers}
        position={location || position}
        ref={markerRef}
      ></Marker>
      <LocateMeButton onChange={onChange} />
      {/* <LocationMarker /> */}
    </MapContainer>
  );
};

export default Location;
